import { Box, Divider, Grid, Typography, useMediaQuery, Button, Card, ButtonBase, CardMedia, CardContent } from "@mui/material";
import { useSelector } from "react-redux";
import WhiteInosio from "../../../icons/whiteinosio.svg";
import ApplicantRegistrationError from "../../../icons/ApplicantRegistrationError.svg";
import { css } from "@emotion/react";
import { HashLoader } from "react-spinners";
import { applicantStyles } from './CustomStyles';
import { ApplicantPageStates } from '../Applicant';
import StartAppIcon from "../../../icons/StartAppIcon.svg";
import ContinueAppIcon from "../../../icons/ContinueAppIcon.svg";
import { selectPropertyGroupDetailsState } from '../../../shared/sagas/propertyGroups/propertyGroupsSlice';
import { selectApplicantsState } from '../sagas/applicants/applicantsSlice';

interface PropsType {
  setPageState: (pageState: ApplicantPageStates) => void,
  isCoApplicantFlow: boolean,
}

export default function ApplicantLanding(props: PropsType) {
  const classes = applicantStyles();
  const matches560 = useMediaQuery("(max-width:560px)");
  const matches900 = useMediaQuery("(max-width:900px)");

  // const { invitedApplicationResponse, isGettingInvitedApplicationFailed } = useSelector(selectApplicationsState);
  const { ApplicationInviteeDetailV2Dto, isFetchingApplicationInviteeInfoFailed } = useSelector(selectApplicantsState);
  const { propertyGroupDetails: PropertyGroupDetails, isFetchingPropertyGroupDetailsFailed } = useSelector(selectPropertyGroupDetailsState);

  const override = css`
    display: block;
    margin: 40% auto;
  `;

  return (
    <Box sx={{ backgroundColor: "#F1F0F5", width: '100vw', height: "100vh", textAlign: 'center' }}>
      <Box sx={{ backgroundColor: "#ffffff", height: 93, display: 'flex', justifyContent: 'space-between', alignItems: 'center', px: '35px' }}>
        <img src={WhiteInosio} style={{ width: "65px", height: "65px" }} alt="logo" />
        {PropertyGroupDetails?.CompanyName && !matches900 && (
          <Box sx={{ position: 'absolute', top: 0, left: 0, right: 0, height: '93px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <Typography className={classes.largeText} sx={{ mb: 0, maxWidth: 340 }}>{PropertyGroupDetails?.CompanyName} Applications</Typography>
          </Box>
        )}
        {(!props.isCoApplicantFlow || isFetchingApplicationInviteeInfoFailed) && (        
        <Button href="/login" className={classes.signInBtn}>
          <Typography className={classes.signInText}>Sign Up | Sign In</Typography>
        </Button>)}
      </Box>

      <Box sx={{ display: 'flex', backgroundColor: '#F1F0F5', flexDirection: 'column', alignItems: 'center', mt: matches900 ? 12: 8 }}>
        <Box className={classes.formContainer} sx={{ width: '100%', maxWidth: 472, padding: "30px 0 40px", backgroundColor: matches560 ? "#F1F0F5": "#ffffff" }}>
          {(isFetchingPropertyGroupDetailsFailed) ? (
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', minHeight: 403, paddingTop: '60px' }}>
              <img src={ApplicantRegistrationError} width={177} height={209} alt='application registration error' />
              <Typography className={classes.errorText} sx={{ mt: 6, mx: 8 }}>No company found for this page URL. Please contact the Property Manager if you feel you have reached this page in error.</Typography>
            </Box>
          ): (isFetchingApplicationInviteeInfoFailed) ? (
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', minHeight: 403, paddingTop: '60px' }}>
              <img src={ApplicantRegistrationError} width={177} height={209} alt='application registration error' />
              <Typography className={classes.errorText} sx={{ mt: 6, mx: 8 }}>No pending co-applicant invitation has been found. If you want to continue an application that you started, please sign in by clicking the link in the top right corner.</Typography>
            </Box>
          ) : PropertyGroupDetails && PropertyGroupDetails?.ApplicationsEnabled  === false ? (
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', minHeight: 403, paddingTop: '60px' }}>
              <img src={ApplicantRegistrationError} width={177} height={209} alt='application registration error' />
              <Typography className={classes.errorText} sx={{ mt: 6, mx: 8 }}>Applications are not currently accepted. Please contact the Property Manager if you feel you have reached this page in error.</Typography>
            </Box>
          ) : PropertyGroupDetails?.CompanyName ? (
            <Box sx={{ height: 478 }}>
              <Typography className={classes.largeText} sx={{ mb: 4.5, maxWidth: 340 }}>{props.isCoApplicantFlow ? `${ApplicationInviteeDetailV2Dto.PrimaryApplicantName} has requested you join their application for ${PropertyGroupDetails?.CompanyName}` : `Thank you for your interest in applying with ${PropertyGroupDetails?.CompanyName}` }</Typography>
              
              {PropertyGroupDetails?.ApplicationsSettings?.ApplicationsPolicyText && <Typography className={classes.bodyText} sx={{ mb: 4.5, maxWidth: 340 }}>We look forward to working with you. Please start by reviewing our application procedures and policies.</Typography>}
        
              <Card sx={{ 
                padding: '0',
                width: 340,
                boxShadow: '0px 0px 40px rgba(0, 0, 0, 0.1)',
                borderRadius: '20px',
                marginTop: '52px !important',
              }}>
                <ButtonBase 
                  sx={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    justifyContent: 'start',
                    width: '100%',
                    padding: '20px 0px 20px 20px',
                    textAlign: 'initial',
                  }}
                  onClick={()=> {
                    if (!ApplicationInviteeDetailV2Dto?.ApplicationUuid) {//It's the primary applicant, so choose address first
                      props.setPageState(ApplicantPageStates.PropertyAddress);
                    } else if (PropertyGroupDetails?.ApplicationsSettings?.ApplicationsPolicyText) {//they have app policies, so take them there.
                      props.setPageState(ApplicantPageStates.ApplicationPolicies);
                    } else if (PropertyGroupDetails?.ApplicationsSettings?.ApplicationsPetPolicyText) {//they have pet policies, so take them there
                      props.setPageState(ApplicantPageStates.PetPolicies);
                    } else {//none of the above, so take them to registration page
                      props.setPageState(ApplicantPageStates.Registration);
                    }
                  }}
                >
                  <CardMedia
                    component="img"
                    sx={{ width: 31, mx: '20px' }}
                    image={StartAppIcon}
                    alt="Start Application"
                  />
                  <CardContent>
                    <Typography sx={{
                      fontFamily: "Open Sans",
                      fontStyle: 'normal',
                      fontWeight: 600,
                      fontSize: '18px',
                      lineHeight: '25px',
                      color: '#14142B',
                    }}>
                      {/* if it's the coapplicant flow, simply show this button */}
                      {props.isCoApplicantFlow ? 'Click here to get started' :                    
                      (PropertyGroupDetails?.ApplicationsSettings?.ApplicationsPolicyText || PropertyGroupDetails?.ApplicationsSettings?.ApplicationsPetPolicyText) ? 'Start new application' : //There are some kind of policies, so show them those first.
                      !props.isCoApplicantFlow ? 'Start New Application' : //there are no policies and it's a primary applicant
                      'Add co-applicant details' //there are no policies and it's a co-applicant
                      }
                    </Typography>
                  </CardContent>
                </ButtonBase>
              </Card>
              {!props.isCoApplicantFlow && (              
              <Card sx={{ 
                padding: '0',
                width: 340,
                boxShadow: '0px 0px 40px rgba(0, 0, 0, 0.1)',
                borderRadius: '20px',
                marginTop: '30px !important',
              }}>
                <ButtonBase 
                  href='/login'
                  sx={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    justifyContent: 'start',
                    width: '100%',
                    padding: '20px 0px 20px 20px',
                    textAlign: 'initial',
                  }}
                >
                  <CardMedia
                    component="img"
                    sx={{ width: 31, mx: '20px' }}
                    image={ContinueAppIcon}
                    alt="Continue Application"
                  />
                  <CardContent>
                    <Typography sx={{
                      fontFamily: "Open Sans",
                      fontStyle: 'normal',
                      fontWeight: 600,
                      fontSize: '18px',
                      lineHeight: '25px',
                      color: '#14142B',
                    }}>
                      Continue Pending Application
                    </Typography>
                  </CardContent>
                </ButtonBase>
              </Card>)}
            </Box>
          ) : (
            <Box sx={{ width: '100%', minHeight: 463 }}>
              <HashLoader color={"#D3D3D3"} loading={true} size={100} css={override} />
            </Box>
          )}
        </Box>
        {
          matches900 ? <></> : <Grid item sx={{ width: '100%', maxWidth: 523, mt: 9 }}>
            <Divider />
            <Grid item display='flex' justifyContent='center'>
              <span className={classes.forgetText}
                onClick={() => {
                  window.open("http://support.inosio.com/");
                }}
              >
                {"Need help?"}
              </span>
            </Grid>
          </Grid>
        }
      </Box>
    </Box >
  );
}
